<template>
  <v-checkbox style="height: 24px;width: 24px;" readonly  v-model="model[`${prop.value}`]" :color="prop.color"></v-checkbox>
</template>

<style scoped>

</style>

<script>
  import CellCheckbox from "./cellCheckbox.ts";
  export default CellCheckbox;
</script>